export default "__VITE_ASSET__6z3xDyAD__"